import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/AppShell';
import { ComingSoon } from '@/components/shared/ComingSoon';

export const Route = createFileRoute('/stranke')({
  component: StrankaPage,
});

function StrankaPage() {
  return (
    <AppShell pageTitle="Stranke" crumb="TradeCraft · Stranke">
      <ComingSoon
        headline="Stranke"
        lead="Mini CRM — vsaka stranka je entiteta s historio klicev, ponudb in opomb za naslednji obisk."
      />
    </AppShell>
  );
}
